export const GET_ZONES = 'GET_ZONES';
export const GET_ZONES_SUCCESS = 'GET_ZONES_SUCCESS';
export const GET_ZONES_FAIL = 'GET_ZONES_FAIL';

export const ADD_ZONE = 'ADD_ZONE';
export const ADD_ZONE_SUCCESS = 'ADD_ZONE_SUCCESS';
export const ADD_ZONE_FAIL = 'ADD_ZONE_FAIL';

export const UPDATE_ZONE = 'UPDATE_ZONE';
export const UPDATE_ZONE_SUCCESS = 'UPDATE_ZONE_SUCCESS';
export const UPDATE_ZONE_FAIL = 'UPDATE_ZONE_FAIL';

export const DELETE_ZONE = 'DELETE_ZONE';
export const DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS';
export const DELETE_ZONE_FAIL = 'DELETE_ZONE_FAIL';

export const SET_ZONE_FIELD_ERRORS = 'SET_ZONE_FIELD_ERRORS';